<script setup lang="ts">
const { t } = useI18n()

const route = useRoute()

const instructionsList = computed(() => {
    return [
        {
            label: t('confirmation.instructions.label0')
        },
        {
            label: t('confirmation.instructions.label1')
        },
        {
            label: t('confirmation.instructions.label2')
        },
        {
            label: t('confirmation.instructions.label3')
        },
        {
            label: t('confirmation.instructions.label4')
        }
    ]
})

const sectionTrackingAttributes = computed(() => {
    return [
        { track: 'view' },
        { 'track-position': 2 },
        { section: 'confirmation-instructions', },
        { 'track-name': t('confirmation.instructions.headline') },
        { 'track-url': route.fullPath }
    ]
})

const sectionTracking = computed(() => {
    if (!sectionTrackingAttributes.value) return {}

    const attributes = {}

    sectionTrackingAttributes.value.forEach((obj) => {
        for (const [key, value] of Object.entries(obj)) {
            attributes[`data-${key}`] = value
        }
    })
    return attributes
})
</script>

<template>
    <section class="confirmation-instructions-outer" data-color-scheme="light" v-bind="sectionTracking">
        <div class="confirmation-instructions-wrapper">
            <div class="confirmation-instructions-container">
                <div class="confirmation-instructions-text">
                    <Subline :subline-config="{ title: t('confirmation.instructions.subline') }" />
                    <ContentHeadline :content-headline-config="{ title: t('confirmation.instructions.headline') }" />
                </div>
                <div class="confirmation-instructions-text">
                    <ul class="confirmation-instructions-list">
                        <li v-for="({ label }, index) in instructionsList" :key="index + label" v-html="label" />
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
.confirmation-instructions-outer {
    overflow: hidden;
    position: relative;
    grid-column: 1 / -1;
    background: $confirmation-instructions-bg;
    @include fullbleed;
}

.confirmation-instructions-wrapper {
    grid-column: 2 / -2;
    @include section-padding;
}

.confirmation-instructions-container {
    display: grid;
    position: relative;

    @include bp(medium1) {
        grid-template-columns: repeat(2, 1fr);
        gap: px2rem(100);
        padding-block: px2rem(20);
    }

    @include bp(large1) {
        gap: px2rem(200);
    }

    &::before {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-100%);
        background: $confirmation-instructions-container-divider;
        width: 2px;
        height: 100%;
        display: none;

        @include bp(medium1) {
           display: block;
        }
    }
}

.confirmation-instructions-text {
    text-align: center;

    @include bp(medium1) {
        text-align: left;
    }

    strong {
        display: block;

        @include bp(medium1) {
            display: inline;
        }
    }
}

.confirmation-instructions-list {
    list-style-type: none;
    padding: 0;
    margin: 0;

    @include bp(medium1) {
        margin: -6px 0 0;
    }

    li {
        margin-block-end: px2rem(20);

        &:last-child {
            margin-block-end: 0;
        }
    }
}
</style>
